import { useStore } from 'vuex';

export const globalVariables = {
  closeAllDropdown: false,
  Conditions: {
    user_updated_at: "none"
  },
  authorizationToken: () => {
    const token = localStorage.getItem(process.env.MIX_USER_SESSION_VARIABLE_NAME);
    return token ? JSON.parse(token).token.access_token : '';
  },
  
  authenticatedUser: (store) => { 
    // const store = useStore();   
    if (!store.state.activeUser || Object.keys(store.state.activeUser).length === 0) {
      const user = JSON.parse(localStorage.getItem(process.env.MIX_USER_SESSION_VARIABLE_NAME));
      store.commit("UPDATE_USER_INFO", user);
      return user;
    }
    return store.state.activeUser;
  },
  Summaries: (store) => {
    // const store = useStore();
    return Object.keys(store.state.summaries).length > 0 ? store.state.summaries : false;
  },
  userSettings: () => {
    const settings = localStorage.getItem(process.env.MIX_USER_SESSION_VARIABLE_NAME);
    return settings ? JSON.parse(settings).settings : false;
  },
  Variables: (store) => {
    // const store = useStore();
    return Object.keys(store.state.variables).length > 0 ? store.state.variables : false;
  },
  ffaNote: 'Note that free freight covers the cost of standard freight. Accessorial charges like excessive length fees, residential fees, liftgate fees etc must be covered by the customer.',
  shipDateNote: 'Please note - we do our best to ship as quickly as possible, but sometimes there are unavoidable delays. Estimated ship dates are approximate and sometimes product may ship after the estimated ship dates. Orders with assembled items may wait until the assembled items are ready to be shipped.'
};